import { Box, Button, Grid } from "@material-ui/core";
import { useSessaoAtual, useToastSaurus } from "../../../../../../services/app";
import { useHistory, useLocation } from "react-router-dom";
import { CircularLoading } from "../../../../../components";
import { useThemeQueries } from "../../../../../theme";
import { VoltarIcon } from "../../../../../components/icons";
import { ConfirmarIcon } from "../../../../../components/icons/confirmar-icon";
import { PedidoModel } from "../../../../../../model/api/pedidos/pedido-model";
import { CardInfoConfirmarEntregaMotoboy } from "../../../../../components/cards/card-info-confirmar-entrega-motoboy/card-info-confirmar-entrega-motoboy";
import { usePedidos } from "../../../../../../hooks/pedidos";
import { useEmpresaAtual } from "../../../../../../services/app/use-cases/empresa-atual";
import { EnumEmpresaConfig } from "../../../../../../model/enums/enum-empresa-config";
import { EnumAssinatura } from "../../../../../../model/enums/enum-assinatura";
import { ActionQueryModel } from "../../../../../../model/app/master/action-query-model";
import { useAbrirApp } from "../../../../../../hooks/abrir-app";
import { useConfirm } from "material-ui-confirm";
import { VariaveisAmbiente } from "../../../../../../config";
import { EnumCodigosPermissoes } from "../../../../../../model/enums/enum-codigos-permissoes";
import { comprimirUrl } from "../../../../../../utils/comprimir-dados";

export const ConfirmarEntregaDataMotoboy = () => {

    const history = useHistory();
    const { showToast } = useToastSaurus();
    const { isMobile } = useThemeQueries();
    const { concluirPedidoEntrega, carregando } = usePedidos()
    const { getConfigByCod } = useEmpresaAtual()
    const { abrirApp } = useAbrirApp()
    const confirm = useConfirm()
    const { getPermissaoBoolean } = useSessaoAtual()

    const location = useLocation();
    const state = location.state as { pedido: PedidoModel };
    const model = state?.pedido

    const handleIniciarVenda = async () => {
        const query: ActionQueryModel<{ pedidoId: string }> = {
            type: 'importarPedidoById',
            query: {
                pedidoId: model?.id ?? '',
            },
            backTo: VariaveisAmbiente.packageNameKds,
        }

        const actionStr = comprimirUrl(JSON.stringify(query))

        abrirApp(VariaveisAmbiente.packageNamePdv, actionStr)
        return true
    }

    const podeRealizarVenda = getPermissaoBoolean(EnumCodigosPermissoes.REALIZAR_VENDAS)

    const confirmarEntrega = async () => {
        try {
            if (model.pagamentos?.some(pag => pag.pagamentoAReceber)) {
                try {
                    await confirm({
                        title: 'Confirmar a entrega do pedido',
                        description: 'O pedido possui pagamentos à receber. O pagamento já foi confirmado?',
                        confirmationButtonProps: {
                            color: 'primary',
                            variant: 'contained',
                        },
                        cancellationText: 'Cancelar',
                        confirmationText: 'Confirmar'
                    })
                } catch (err: any) {
                    throw new Error('Confirmação de entrega cancelada')
                }
            }

            const assinatura = getConfigByCod(EnumEmpresaConfig.ConfirmacaoClienteMesa)
            if (Number(assinatura) === EnumAssinatura.PermiteAssinatura) {
                history.replace({
                    pathname: '/assinatura',
                    state
                })
                return
            }
            if (podeRealizarVenda) {
                confirm({
                    title: 'Confirmar a entrega do pedido',
                    description: 'Você pode apenas marcar como entregue ou, se preferir, finalizar a venda agora. Deseja finalizar a venda?',
                    confirmationButtonProps: {
                        color: 'primary',
                        variant: 'contained',
                    },
                    cancellationText: 'Entregar',
                    confirmationText: 'Finalizar venda'
                })
                    .then(async () => {
                        try {
                            await concluirPedidoEntrega(model?.id)
                            await handleIniciarVenda()
                            history.push('/')
                        } catch (err: any) {
                            showToast('error', err.message);
                            return
                        }
                    })
                    .catch(async () => {
                        try {
                            await concluirPedidoEntrega(model?.id)
                        } catch (err: any) {
                            showToast('error', err.message);
                            return
                        }
                        history.push('/')
                        return
                    })
                    return
            }
            await concluirPedidoEntrega(model?.id)
            history.push('/')
        } catch (err: any) {
            showToast('error', err.message);
        }
    }

    return (
        <>
            {carregando && <CircularLoading tipo="FULLSIZED" />}
            <Grid container style={{
                padding: '16px',
                display: 'flex',
                justifyContent: 'center',
                height: isMobile ? '100%' : undefined
            }}>
                <Grid item xs={12} style={{
                    maxWidth: '600px',
                    height: '100%',
                    display: 'flex',
                }}>
                    <Grid container spacing={2}>
                        <Grid item xs={12} style={{
                            display: 'flex',
                            justifyContent: 'center',
                            flexDirection: 'column',
                            gap: '16px',
                            height: '100%'
                        }}>
                            <Box height={isMobile ? 0 : undefined} flex={isMobile ? 1 : undefined}>
                                <CardInfoConfirmarEntregaMotoboy
                                    model={model}
                                />
                            </Box>
                            <Grid container spacing={2}>
                                {!isMobile && (
                                    <Grid item xs={6}>
                                        <Button
                                            variant="outlined"
                                            fullWidth
                                            color="primary"
                                            size="large"
                                            startIcon={<VoltarIcon tipo="BUTTON_LOGOUT" />}
                                            onClick={() => history.push('/entregas-pendentes')}
                                        >
                                            <Box fontWeight={700}>
                                                Voltar
                                            </Box>
                                        </Button>
                                    </Grid>
                                )}
                                <Grid item xs={isMobile ? 12 : 6}>
                                    <Button
                                        variant="contained"
                                        color="primary"
                                        size="large"
                                        fullWidth
                                        startIcon={<ConfirmarIcon tipo="BUTTON_PRIMARY" />}
                                        onClick={confirmarEntrega}
                                    >
                                        <Box fontWeight={700}>
                                            Confirmar Entrega
                                        </Box>
                                    </Button>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid >
        </>
    )
}